var _circle, _circle2, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeadEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 150,
    viewBox: "0 0 152 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 98.0007,
    r: 52,
    fill: "#AFFFD1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53.0007,
    r: 50,
    stroke: "#16161E",
    strokeWidth: 6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: -3,
    x2: 22.6356,
    y2: -3,
    transform: "matrix(0.715187 0.698933 -0.715187 0.698933 31 51.8872)",
    stroke: "#16161E",
    strokeWidth: 6,
    strokeLinecap: "square"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: -3,
    x2: 38.4334,
    y2: -3,
    transform: "matrix(0.715187 -0.698933 0.715187 0.698933 49.5215 69.9595)",
    stroke: "#16161E",
    strokeWidth: 6,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadEnd);
export default __webpack_public_path__ + "static/media/lead_end.ea888ae0d1f62f58b53f93378f5243bd.svg";
export { ForwardRef as ReactComponent };